import { GeneralFieldsBlock } from "@/react/components/shared/BuilderUI/constants/BlockCategories";
import { ContentProp } from "@/react/components/shared/BuilderUI/constants/PropCategories";

export const meta = {
  name: "Dropdown",
  version: 1,
  nameI18n: "builder_ui.block_type.form_dropdown",
  category: [GeneralFieldsBlock],
  props: {
    label: {
      prop: "other",
      type: "string",
      name: "Label",
      nameI18n: "builder_ui.prop_type.label",
      category: [ContentProp],
    },
    required: {
      prop: "other",
      type: "boolean",
      name: "Required",
      nameI18n: "builder_ui.prop_type.required",
      category: [ContentProp],
    },
    options: {
      prop: "custom",
      type: "choice-options",
      name: "Options",
      nameI18n: "builder_ui.prop_type.options",
      category: [ContentProp],
    },
  },
} as const;
